module.exports = __webpack_public_path__ + "img/titulo.8bff4b6e.png";